export {}

const userItems = document.querySelectorAll<HTMLElement>(".i-user")

userItems.forEach((item) => {
  const dropdown = document.querySelector<HTMLElement>(".i-header-dropdown")
  if (!dropdown) return

  item.addEventListener("click", (e) => {
    dropdown.classList.add("--open")
    e.preventDefault()
  })
})
